/**
 * Helper function to check if a tab or its sub-items is active
 * @param tabKey The key of the tab to check
 * @param currentPath The current URL path
 * @returns boolean indicating if the tab is active
 */
export const isTabActive = (tabKey: string, currentPath: string): boolean => {
  // Handle root path
  if (currentPath === '/msg' && tabKey === 'overview') return true;
  
  const pathSegments = currentPath.split('/').filter(Boolean);
  // Remove 'msg' from the path segments if present
  if (pathSegments[0] === 'msg') {
    pathSegments.shift();
  }
  
  // If no segments left, we're at the overview
  if (pathSegments.length === 0) {
    return tabKey === 'overview';
  }
  
  const currentTab = pathSegments[0] || 'overview';
  const currentSubTab = pathSegments[1] || '';
  const currentSubSubTab = pathSegments[2] || '';
  
  // Handle different levels of nesting
  if (currentSubSubTab) {
    // For three-level paths (e.g., support/competency/overview)
    const fullTabKey = `${currentTab}.${currentSubTab}.${currentSubSubTab}`;
    return fullTabKey === tabKey || fullTabKey.startsWith(`${tabKey}.`);
  } else if (currentSubTab) {
    // For two-level paths (e.g., context/issues)
    const fullTabKey = `${currentTab}.${currentSubTab}`;
    return fullTabKey === tabKey || fullTabKey.startsWith(`${tabKey}.`);
  } else {
    // For top-level paths (e.g., overview, context, etc.)
    return currentTab === tabKey || tabKey.startsWith(`${currentTab}.`);
  }
};
